<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: null,
                    },
                ]"
            />
        </template>

        <template v-slot:pre>
            <div class="my-3 max-w-7xl mx-auto" v-if="widgets.length">
                <!--        Widgets section-->
                <DashboardTeacherWidgets :widgets="widgets" />
            </div>
        </template>

        <div class="mt-3">
            <img src="/img/utils/undraw_Organizing_projects_re_9p1k.svg" alt="empty state" />
        </div>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import DashboardTeacherWidgets from '@/components/DashboardTeacherWidgets.vue';

export default {
    components: {
        DashboardTeacherWidgets,
        PanelPage,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'widgets'],
};
</script>
